import { create } from 'zustand';
import { io, type Socket } from 'socket.io-client';
import { useAuthStore } from './auth.ts';

interface SocketState {
  socket: Socket | null;
  connect: () => void;
  disconnect: () => void;
}

export const useSocketStore = create<SocketState>((set, get) => ({
  socket: null,
  connect: () => {
    if (get().socket) return;
    const token = useAuthStore.getState().accessToken;
    if (!token) return;
    const s = io({ path: '/socket.io', auth: { token }, transports: ['websocket'] });
    set({ socket: s });
  },
  disconnect: () => {
    get().socket?.disconnect();
    set({ socket: null });
  },
}));
